import apiClient from '../../shared/api/client';

export interface BillingCharge {
  id: number;
  amount_cents: number;
  currency: string;
  created_at: string;
  processor_id: string;
  receipt_url: string | null;
  invoice_pdf_url: string | null;
  description: string;
  purchased_by: { id: number; name: string } | null;
}

export interface BillingSubscription {
  id: string;
  status: string;
  plan_name: string | null;
  current_period_end: string | null;
  cancel_at_period_end: boolean;
  quantity: number;
}

export interface BillingPaymentMethod {
  brand: string | null;
  last4: string | null;
  exp_month: number | null;
  exp_year: number | null;
}

export interface BillingRegistration {
  id: string;
  kind: 'event' | 'course';
  date: string | null;
  description: string;
  detail: string | null;
  amount_cents: number | null;
  currency: string;
  payment_method: string | null;
  status: string;
  receipt_url: string | null;
  /** Invoice this registration was billed on, when one exists (invoice or
   *  purchase_order payments). `url` is the legacy WordPress invoice URL
   *  when applicable — null when the invoice was created post-cutover and
   *  has no public link yet (the UI hides the Copy/Pay buttons in that
   *  case rather than offering a dead action). */
  invoice: {
    id: number;
    status: 'paid' | 'unpaid' | 'void';
    url: string | null;
  } | null;
}

export interface BillingData {
  context: 'personal' | 'org';
  subject: { name: string };
  subscription: BillingSubscription | null;
  payment_method: BillingPaymentMethod | null;
  charges: BillingCharge[];
  registrations: BillingRegistration[];
  /** Count of unpaid invoices across the current billing surface — drives
   *  the sidebar badge on the Billing nav item. Zero when nothing is owed. */
  unpaid_invoices_count: number;
}

export const billingApi = {
  get: async (): Promise<BillingData> => {
    const { data } = await apiClient.get('/billing');
    return data;
  },
  portal: async (): Promise<{ url: string }> => {
    const { data } = await apiClient.post('/billing/portal');
    return data;
  },
};
